module.exports = __webpack_public_path__ + "img/oran_11kl.be28d1f3.jpg";